// NewCustomer.jsx
import React from 'react'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet-async'
import { injectIntl } from 'react-intl'
import { useNavigate, useParams } from 'react-router-dom'

import NavigationBar from '../partials/NavigationBar'
import Footer from '../partials/Footer'
import NewCustomer from '../partials/DistributorComponents/AddCustomer'
import withAppStore from '../../util/withAppStore'

import AppStore from '../../stores/AppStore'
import styles from '../../../css/home.module.css'

function NewCustomers (props) {
  const navigate = useNavigate()
  const params = useParams()

  const [state, setState] = React.useState({
    page: 1,
    maxPage: 1,
  })

  const goTo = React.useCallback(x => navigate(x), [navigate])

  const goBack = React.useCallback(() => {
    const { id: customerID } = AppStore.getCustomer()
    goTo(`/${customerID}/distributor/transferDevices`)
  }, [goTo])

  const nextPage = React.useCallback(() => {
    const { maxPage, page } = state
    setState(prevState => ({
      ...prevState,
      page: page + 1,
      maxPage: Math.max(maxPage, page + 1)
    }))
  }, [state])

  const unhide = React.useCallback(() => {
    setState(prevState => ({ ...prevState, shouldHide: false }))
  }, [])

  const setPage = React.useCallback((page) => {
    const { maxPage } = state
    return (e) => {
      if (e) {
        e.preventDefault()
      }
      setState(prevState => ({
        ...prevState,
        page: Math.min(page, maxPage)
      }))
      return false
    }
  }, [state])

  const previousPage = React.useCallback((currentData) => {
    const { page } = state
    if (page === 1) {
      goBack()
    } else {
      setState(prevState => ({
        ...prevState,
        page: page - 1,
        currentData,
      }))
    }
  }, [state, goBack])

  const {
    auth: {
      logout,
    },
    route: {
      path,
    },
    intl: {
      formatMessage,
    },
    data,
  } = props

  const { page, currentData } = state
  const { id: customerID } = AppStore.getCustomer()

  const NEW_CUSTOMER = formatMessage({
    id: 'customer.distributor.transferDevices',
    defaultMessage: 'Transfer Devices',
    description: 'Transfer Devices label',
  })

  return (
    <div>
      <Helmet><title>{NEW_CUSTOMER}</title></Helmet>
      <NavigationBar
        backFunc={previousPage}
        page={path}
        name={NEW_CUSTOMER}
        logOut={() => logout(navigate)}
      />
      <div className={styles.pageWidth}>
        <div>
          <div className={styles.pageContainer}>
            <section>
              <NewCustomer user={AppStore.getUser()} data={data} params={params} customerID={customerID} nextPage={nextPage} previousPage={previousPage} page={page} currentData={currentData} />
            </section>
            <br />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  )
}

NewCustomers.propTypes = {
  auth: PropTypes.object,
  route: PropTypes.object,
  intl: PropTypes.object,
  data: PropTypes.object,
}

export default withAppStore(injectIntl(NewCustomers))
